import React from 'react';
import { AlertCircle } from 'lucide-react';
import { getScoreGrade } from '../../models/analysis';
import { ScoreFlags } from '../shared/ScoreDisplay';

export function ScoreCard({ analysis }) {
  const grade = getScoreGrade(analysis.hqScore);

  return (
    <div className="msml-card !p-5 text-center msml-slide-up relative overflow-hidden" data-testid="score-card">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{ background: `radial-gradient(ellipse at center, ${grade.color} 0%, transparent 70%)` }}
      />
      <span className="msml-label relative z-10">HQ Score</span>
      <div className={`msml-score ${grade.cssClass} mt-2 relative z-10`} data-testid="hq-score-value">
        {Math.round(analysis.hqScore)}
      </div>
      <p className="text-sm mt-1 relative z-10" style={{ color: grade.color }} data-testid="score-grade">
        {grade.label}
      </p>
      {analysis.hqScoreRaw != null && analysis.hqScoreRaw !== analysis.hqScore && (
        <p className="text-xs text-[var(--msml-text-muted)] mt-1 relative z-10">Raw: {Math.round(analysis.hqScoreRaw)}</p>
      )}
      <div className="relative z-10 mt-3">
        <ScoreFlags flags={analysis.flags} capsApplied={analysis.capsApplied} />
      </div>
    </div>
  );
}
